import { ProjectionLike, transform } from 'ol/proj';

import { CropField } from '../models';

export function transformedCropFields(
  cropFields: CropField[],
  source: ProjectionLike,
  destination: ProjectionLike,
) {
  return cropFields.map((cropField) => ({
    ...cropField,
    feature: cropField.feature
      ? {
          ...cropField.feature,
          cropId: cropField.cropId,
          geometry: {
            ...cropField.feature.geometry,
            coordinates: cropField.feature?.geometry.coordinates.map((coordinateArray) =>
              coordinateArray?.map((coordinate) => transform(coordinate, source, destination)),
            ),
          },
        }
      : null,
  }));
}
